define("settings/templates/overview/downgrade", ["exports", "@ember/template-factory"], function (_exports, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars"eaimeta@70e063a35619d71f
  var _default = _exports.default = (0, _templateFactory.createTemplateFactory)(
  /*
    <DowngradeSetup
    @initialHasOverageGroups={{this.initialHasOverageGroups}}
    @initialHasOverageLinkinBioPages={{this.initialHasOverageLinkinbioPages}}
    @initialHasOverageSocialSets={{this.initialHasOverageSocialSets}}
    @initialHasOverageUsers={{this.initialHasOverageUsers}}
    @organizeSocialProfiles={{this.organizeSocialProfiles}}
    @recentlyExpiredPlan={{@model.recentlyExpiredPlan}}
    @socialSets={{@model.socialSets}}
    @totalSocialSets={{@model.totalSocialSets}}
    @updateInitialHasOverageLinkinbioPages={{this.updateInitialHasOverageLinkinbioPages}}
  />
  */
  {
    "id": "NrGX7aT0",
    "block": "[[[8,[39,0],null,[[\"@initialHasOverageGroups\",\"@initialHasOverageLinkinBioPages\",\"@initialHasOverageSocialSets\",\"@initialHasOverageUsers\",\"@organizeSocialProfiles\",\"@recentlyExpiredPlan\",\"@socialSets\",\"@totalSocialSets\",\"@updateInitialHasOverageLinkinbioPages\"],[[30,0,[\"initialHasOverageGroups\"]],[30,0,[\"initialHasOverageLinkinbioPages\"]],[30,0,[\"initialHasOverageSocialSets\"]],[30,0,[\"initialHasOverageUsers\"]],[30,0,[\"organizeSocialProfiles\"]],[30,1,[\"recentlyExpiredPlan\"]],[30,1,[\"socialSets\"]],[30,1,[\"totalSocialSets\"]],[30,0,[\"updateInitialHasOverageLinkinbioPages\"]]]],null]],[\"@model\"],false,[\"downgrade-setup\"]]",
    "moduleName": "settings/templates/overview/downgrade.hbs",
    "isStrictMode": false
  });
});